import React from 'react'
import {
    OverContainerSection,
    ContentEffect,
    OverContainerColor,
    EffectColor,
    EffectColorInvert,
    TitleSection,
    ContentMapSection,
} from './styles'
import Effect from 'src/assets/WereHiring/Effect'
import { WereHiringLabels } from 'src/constants/WereHiringLabels'
import { MapSection } from './MapSection'
import { useTranslations } from 'src/provider/LocaleProvider'

interface Props {
    viewTop: string
    viewBottom: string
}

export const EffectSection = ({ viewTop, viewBottom }: Props) => {
    const t = useTranslations()
    const { WereHiringContent } = WereHiringLabels()

    return (
        <OverContainerSection>
            <EffectColor>
                <Effect viewBox={viewTop} />
            </EffectColor>
            <OverContainerColor>
                <ContentEffect
                    marginBottom={['medium', 'medium', 'large', 'titlle']}
                >
                    <TitleSection>{t('worldWile.heading')}</TitleSection>
                    <ContentMapSection marginTop={'xtitle'}>
                        {WereHiringContent.map((were) => (
                            <MapSection key={were.id} {...were} />
                        ))}
                    </ContentMapSection>
                </ContentEffect>
            </OverContainerColor>
            <EffectColorInvert>
                <Effect viewBox={viewBottom} />
            </EffectColorInvert>
        </OverContainerSection>
    )
}
